module.exports = __webpack_public_path__ + "img/gold.9e21c0b5.svg";